import {
  RADAR_RAIL_STATUS_CODE_PATH,
  ResultStatus,
} from '@web-platform/shared-universal-constants/src/radar';
import get from 'lodash/get';

import type { RadarResponsePayload } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarResponsePayloadTypes';

export function isRailResponseNonRetryError(response: RadarResponsePayload): boolean {
  return get(response, RADAR_RAIL_STATUS_CODE_PATH, ResultStatus.COMPLETE) === ResultStatus.FAILURE;
}
